// extracted by mini-css-extract-plugin
export default {"wrapper":"L2-z"};